import React from 'react';
import useModalBehavior from '../../../hooks/useModalBehavior';

const TemplatesModal = ({
  showTemplates,
  templates,
  onClose,
  onApplyTemplate,
  templateTargetLineId
}) => {
  const panelRef = useModalBehavior({ isOpen: showTemplates, onClose });

  if (!showTemplates) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleTemplateClick = (templateData) => {
    onApplyTemplate(templateTargetLineId, templateData);
  };

  const handleTemplateKeyDown = (e, templateData) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onApplyTemplate(templateTargetLineId, templateData);
    }
  };

  return (
    <div
      className="modal-overlay"
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="template-modal-title"
    >
      <div
        className="modal-content"
        onClick={e => e.stopPropagation()}
        ref={panelRef}
        tabIndex={-1}
      >
        <h3 id="template-modal-title">Apply Template</h3>
        <div className="templates-grid" role="radiogroup" aria-label="Template options">
          {templates.map((template, idx) => (
            <div
              key={idx}
              className="template-option"
              onClick={() => handleTemplateClick(template.data)}
              onKeyDown={(e) => handleTemplateKeyDown(e, template.data)}
              tabIndex={0}
              role="button"
              aria-label={`Apply ${template.name} template`}
            >
              <strong>{template.name}</strong>
              <div className="template-details">
                {Object.entries(template.data).map(([k, v]) => (
                  <span key={k}>{k}: {v}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
        <button onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
};

export default TemplatesModal;